import React from 'react';
import {
  Box,
  Heading,
  Flex,
  Text,
  IconButton,
  Image,
  HStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { MdDelete } from 'react-icons/md';

import W from '../../images/games/icons/W.png';
import U from '../../images/games/icons/U.png';
import B from '../../images/games/icons/B.png';
import R from '../../images/games/icons/R.png';
import G from '../../images/games/icons/G.png';
import C from '../../images/games/icons/C.png';

function ParticipantsList({ participants, onRemove }) {
  // Map color codes (like "W") to an icon path
  const colorSymbols = {
    W, // White mana
    U, // Blue mana
    B, // Black mana
    R, // Red mana
    G, // Green mana
    C, // Colorless mana
  };

  // Semi-transparent row BG
  const rowBg = useColorModeValue('purple.700', 'whiteAlpha.200');

  if (!participants.length) {
    return (
      <Box mt={4}>
        <Heading as="h3" size="sm">
          Partecipanti (nessuno)
        </Heading>
      </Box>
    );
  }

  return (
    <Box
      mt={0}
      p={4}
      w="100%"
      maxW="400px"
      bg={useColorModeValue('whiteAlpha.200', 'blackAlpha.300')}
      borderRadius="md"
      backdropFilter="blur(4px)" // optional "frosted glass"
    >
      {participants.map((participant) => (
        <Flex
          key={participant.id}
          align="center"
          bg={rowBg}
          p={2}
          mb={2}
          borderRadius="md"
        >
          {/* Participant Name */}
          <Text flex="1" fontWeight="medium" ml={2}>
            #{participant.cardNumber}
          </Text>
          {/* Color Icons */}
          <HStack spacing={1} mx={2}>
            {participant.colors.map((c, index) => {
              const symbol = colorSymbols[c] || '/assets/mana-unknown.png';
              return (
                <Image
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  src={symbol}
                  alt={`mana-${c}`}
                  boxSize="16px"
                />
              );
            })}
          </HStack>
          {' - '}&nbsp;
          {/* Remove Button */}
          <IconButton
            icon={<MdDelete />}
            size="xs"
            borderRadius="50%"
            aria-label="Rimuovi partecipante"
            colorScheme="red"
            variant="solid"
            onClick={() => onRemove(participant.id)}
          />
        </Flex>
      ))}
    </Box>
  );
}

export default ParticipantsList;
